// Handle weapon attachment targeting - Two-step process
const attachWeapon = (targetUnit, ws, setError, setWeaponTargetMode, selectedWeaponId, setSelectedWeaponId, selectedWeaponInstanceId, gameId, userId, gameState, setWeaponDeployTargetMode, setWeaponDeployTargetInfo) => {
  
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  if (!targetUnit) {
    setError("No target unit selected");
    return;
  }

  // Tutorial overlay: only allow attaching to units in allowedWeaponAttachTargetOrderIds (e.g. only Opportunist 302)
  if (typeof document !== 'undefined' && document.body) {
    const attr = document.body.getAttribute('data-tutorial-overlay-weapon-attach-restrict');
    if (attr) {
      try {
        const allowed = JSON.parse(attr);
        if (Array.isArray(allowed) && allowed.length > 0) {
          const allowedSet = new Set(allowed.map(a => Number(a)));
          if (targetUnit.id == null || !allowedSet.has(Number(targetUnit.id))) {
            setError('In this step you can only attach the weapon to the indicated unit');
            return;
          }
        }
      } catch (_) {}
    }
  }

  // Step 1: Send weapon attachment action
  const action = {
    type: "attachWeapon",
    gameId: gameId,
    weaponInstanceId: selectedWeaponInstanceId,
    targetUnitInstanceId: targetUnit.instanceId,
    targetZone: targetUnit.zone,
    targetIndex: targetUnit.index
  };

  ws.send(JSON.stringify(action));
  
  // Don't reset targeting yet - wait for server response
  // The server will respond with needsDeployTargeting flag
};

// Handle weapon deploy targeting (Step 2)
const weaponDeployTarget = (targetUnit, ws, setError, weaponDeployTargetInfo, gameId) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  if (!weaponDeployTargetInfo) {
    setError("No weapon deploy target info available");
    return;
  }

  if (!targetUnit) {
    setError("No target unit selected for deploy effect");
    return;
  }

  // Send weapon deploy target action
  const action = {
    type: "weaponDeployTarget",
    gameId: gameId,
    weaponInstanceId: weaponDeployTargetInfo.weaponInstanceId,
    deployTargets: [{
      targetUnitInstanceId: targetUnit.instanceId,
      targetZone: targetUnit.zone,
      targetIndex: targetUnit.index
    }]
  };

  ws.send(JSON.stringify(action));
};

export default attachWeapon;
export { weaponDeployTarget };
